import {Component, Inject, OnInit} from '@angular/core';
import {Show} from "../../interfaces/show.interface";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ShowsService} from "../../services/shows.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import { environment } from "../../../environments/environment"

@Component({
    selector: 'app-app-link',
    templateUrl: './app-link.component.html',
    styleUrls: ['./app-link.component.scss'],
    standalone: false
})
export class AppLinkComponent implements OnInit {

	show: Show;
	qrcodeUrl = ''
	processing = false;
	appLink = '';
	constructor(private dialogRef: MatDialogRef<AppLinkComponent>,
							@Inject(MAT_DIALOG_DATA) data:any,
							public snackBar: MatSnackBar,
							private showService: ShowsService) {
		this.show = data.show;
		let oneLinkBase = 'https://pyrocastapp.onelink.me/abQ6';
		if (window.location.hostname === environment.skyDomain) {
			oneLinkBase = 'https://skystreamapp.onelink.me/EGmE';
		}
		else if (window.location.hostname === environment.tune2Domain || window.location.hostname === environment.tune2Domain2) {
			oneLinkBase = 'https://tune2app.onelink.me/n7R0';
		}
		else if (window.location.hostname === environment.igniteDomain) {
			oneLinkBase = 'https://igniteliveapp.onelink.me/LYHJ';
		}
		this.appLink = `${oneLinkBase}?deep_link_value=${this.show.show_code}`;
		this.qrcodeUrl = 'https://qrcode.tec-it.com/API/QRCode?data=' + encodeURIComponent(this.appLink) + '&backcolor=%23ffffff&method=download';
	}

	ngOnInit(): void {
	}
	copyAppLink() {
		const link = this.appLink;
		navigator.clipboard.writeText(link).then(
		  () => {
			this.snackBar.open('App Link copied to clipboard', 'Close', {
				duration: 3000, // Duration in milliseconds
			});
			console.log('App Link copied to clipboard');
		  },
		  err => {
			console.error('Could not copy text: ', err);
		  }
		);
	}
	downloadQR() {
		const qrUrl = this.qrcodeUrl;
		const link = document.createElement('a');
		link.href = qrUrl;
		link.download = 'qrcode.png';
		link.click();
		this.snackBar.open('QR Code Downloaded', 'Close', {
		  duration: 3000,
		});
	  }
	  
	cancel() {
		this.dialogRef.close(false);
	}

}
